<template>
    <div class="card card-plain"
        style="margin: 0 auto; background: #FFF; -webkit-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); -moz-box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75); box-shadow: 39px 55px 0px -4px rgba(0,0,0,0.75);">
        <div class="pb-0 card-header text-start">
            <h4 class="font-weight-bolder">Erro</h4>
            <p class="mb-0" style="line-height: 1.3">
                Página não encontrada
            </p>
        </div>
        <div class="card-body">
            Verifique a URL.
            <br>
            <argon-button variant="gradient" class="assinar-btn" color="warning" size="sm" style="margin-top: 10px;" @click="goHome">VOLTAR AO INÍCIO</argon-button>
        </div>
    </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];

export default {
    name: "PageNotFound",
    components: {
        ArgonButton
    },
    created() {
        this.$store.state.hideConfigButton = true;
        this.$store.state.showNavbar = false;
        this.$store.state.showSidenav = false;
        this.$store.state.showFooter = false;
        body.classList.remove("bg-gray-100");
    },
    beforeUnmount() {
        this.$store.state.hideConfigButton = false;
        this.$store.state.showNavbar = true;
        this.$store.state.showSidenav = true;
        this.$store.state.showFooter = true;
        body.classList.add("bg-gray-100");
    },
    methods: {
        goHome() {
            this.$router.push({ name: 'Inicio' })
        }
    }
};
</script>